const data = {
  title: "Drughelp.care",
  news: "News",
  contact: "Contact",
  itemsperpage: "Items per page",
  copyrightFooter: "Copyright ©️2020 drughelp.care, All rights reserved.",
  back: "Back",
  open: "Open",
  privacypolicy: "Privacy Policy",
  closed: "Closed",
  showingservices: "Showing {available} services of {count} available",
  jumpToPage: "Jump to Page",
  termsandconditions: "Terms and Conditions",
  welcome: "Welcome",
  findthesubstanceusetreatmentyouneed: "Find the substance use treatment you need",
  spanish: "Español",
  prev: "PREV",
  next: "NEXT",
  createNew: "Create new",
  service: "Service",
  services: "Services",
  agency: "Agency",
  agencies: "Agencies",
  home: "Home",
  about: "About",
  aboutus: "About Us",
  menu: "Menu",
  faq: "FAQs",
  events: "Events",
  adminLogin: "Admin Login",
  sortBy: "Sort By",
  recentlyUpdated: "Recently Updated",
  agencyNameAtoZ: "Agency Name (A to Z)",
  agencyNameZtoA: "Agency Name (Z to A)",
  distanceFromYou: "Distance From You",
  distanceFromYourZipCode: "Distance From Your Zip Code",
  walkInsOnly: "Walk-Ins Only",
  spanishLanguageServicesFirst: "Spanish Language Services First",
  updated: "updated",
  slotsAreAvailable: "slots are available",
  slotIsAvailable: "slot is available",
  user: "User",
  users: "Users",
  category: "Category",
  categories: "Categories",
  hotline: "Hotline",
  hotlines: "Hotlines",
  hotlinecategories: "Hotline Categories",
  feature: "Feature",
  features: "Features",
  timeInfo: "Time Information",
  timeInfos: "Time Informations",
  search: "Search",
  changePassword: "Change Password",
  routes: {
    dashboard: "Dashboard",
    login: "Login",
    availabilityStatus: "Availability Status"
  },
  view: {
    services: {
      search: "Search",
      searchServices: "Search Services",
      searchResult: '{count} result(s) found for "{term}"',
      openWebSite: "Open Website",
      call: "Call",
      searchError: "Error occured while searching for services",
      noResultsFound: "No matching results found for given search",
      noServicesAvailable: "No services available at this moment",
      viewService: "View service",
      unregisteredService:
        "This treatment service is unregistered or has not been updated in over a year.",
      walkInsWelcome: "Walk-Ins Welcome"
    },
    categories: {
      search: "Search",
      searchCategories: "Search Categories",
      searchResult: '{count} result(s) found for "{term}"',
      openWebSite: "Open Website",
      searchError: "Error occured while searching for categories",
      noResultsFound: "No matching results found for given search",
      noCategoriesAvailable: "No categories available at this moment",
      viewCategory: "View category",
      editCategory: "Edit category",
      addCategory: "Add new category"
    },
    agencies: {
      search: "Search",
      searchAgencies: "Search Agencies",
      searchResult: '{count} result(s) found for "{term}"',
      openWebSite: "Open Website",
      searchError: "Error occured while searching for agencies",
      noResultsFound: "No matching results found for given search",
      noAgenciesAvailable: "No agencies available at this moment",
      viewAgency: "View agency",
      editAgency: "Edit agency",
      addAgency: "Add new agency"
    },
    hotlines: {
      search: "Search",
      searchHotlines: "Search Hotlines",
      searchResult: '{count} result(s) found for "{term}"',
      searchError: "Error occured while searching for hotlines",
      viewHotline: "View Hotline",
      editHotline: "Edit Hotline",
      addHotline: "Add New Hotline",
      noResultsFound: "No matching results found for given search",
      noHotlinesAvailable: "No hotlines available at this moment"
    },
    hotlinecategories: {
      Error: "Error occured while loading the page"
    },
    users: {
      search: "Search",
      searchUsers: "Search Users",
      searchResult: '{count} result(s) found for "{term}"',
      openWebSite: "Open Website",
      searchError: "Error occured while searching for users",
      noResultsFound: "No matching results found for given search",
      noUsersAvailable: "No users available at this moment",
      viewUser: "View user",
      editUser: "Edit user",
      addUser: "Add new user"
    },
    categoryEdit: {
      categoryNotFound: "Category not found."
    },
    features: {
      search: "Search",
      searchFeatures: "Search Features",
      searchResult: '{count} result(s) found for "{term}"',
      openWebSite: "Open Website",
      searchError: "Error occured while searching for Features",
      noResultsFound: "No matching results found for given search",
      noFeaturesAvailable: "No Features available at this moment",
      viewFeature: "View feature",
      editFeature: "Edit feature"
    },
    searchService: {
      searchServices: "Search by Agency Name/Service Name",
      search: "Search",
      downloadResults: "Download Results"
    },
    filterOptions: {
      assessment: "A friendly interview that is the first step in getting help",
      outpatient: "Individual or group counseling",
      intensiveoutpatientprogram: "Group counseling several days each week",
      partialhospitalization: "Day treatment for those with higher needs",
      residential: "You sleep here and get treatment during the day",
      inpatient:
        "Like a hospital for those who require 24/7 medical monitoring",
      recoveryhousingsoberliving: "A sober, supportive place to live",
      peersupportrecovery: "Peer Support/Recovery",
      communityadvocates: "Community Advocates",
      recoverymeetingsgroups: "Recovery Meetings/Groups",
      familysupportgroups: "Family Support Groups",
      hivhepatitistesting: "HIV/Hepatitis Testing",
      obtainingnarcan: "Obtaining Narcan",
      needleexchange: "Needle Exchange",
      drugeducation: "Drug Education",
      pregnancyprevention: "Pregnancy Prevention",
      fentanyltestingstrips: "Fentanyl Testing Strips",
      unuseddrugdisposal: "Unused Drug Disposal"
    },
    defaultText: {
      default: "Default Content"
    },
    mainPage: {
      quickSearchHeading: "Quick Search",
      quickSearchSubHeading:
        "Answer a few questions to find treatment services",
      advancedSearchHeading: "Advanced Search",
      advancedSearchSubHeading:
        "Use more than 100 filters to find treatment services"
    },
    otherResources: {
      otherresources: "Other Resources",
      harmreductionbutton: "HARM REDUCTION",
      harmreduction:
        "Resources to stay alive and improve personal and community health",
      freenaloxonebutton: "Free Naloxone",
      freenaloxone: "Obtain free naloxone",
      peerandfamilysupportbutton: "PEER AND FAMILY SUPPORT",
      peerandfamilysupport: "Services for those in recovery and their families",
      crisishotlinebutton: "Crisis Hotlines",
      crisishotlinedefault: "Access crisis hotlines",
      crisishotlinecount: "Access {count} crisis hotlines"
    },
    categoryNames: {
      harmreduction: "Harm Reduction",
      treatmentservices: "Treatment Services",
      peerandfamilysupport: "Peer and Family Support",
      crisishotlines: "Crisis Hotlines"
    },
    filterYourResults: {
      treatmentservices: {
        loading: "Loading...",
        treatmentservices: "Treatment Services",
        assessment: "Assessment",
        inpatient: "Inpatient",
        intensiveoutpatientprogram: "Intensive Outpatient Program",
        outpatient: "Outpatient",
        partialhospitalization: "Partial Hospitalization",
        recoveryhousingsoberliving: "Recovery Housing/Sober Living",
        residential: "Residential",
        harmreduction: "Harm Reduction",
        drugeducation: "Drug Education",
        hivhepatitistesting: "HIV & Hepatitis Testing",
        naloxbox: "NaloxBox",
        narcannaloxone: "Narcan (Naloxone)",
        needleexchange: "Needle Exchange",
        saferusekits: "Safer Use Kits",
        testingstrips: "Testing Strips",
        unuseddrugdisposal: "Unused Drug Disposal",
        woundcare: "Wound Care",
        peerandfamilysupport: "Peer and family support",
        communityadvocates: "Community Advocates",
        familysupportgroups: "Family Support Groups",
        peersupportrecovery: "Peer Support Recovery",
        recoverycommunityorganization: "Recovery Community Organization",
        recoverymeetingsgroups: "Recovery Meetings & Groups"
      },
      virtualservices: {
        virtualservices: "Virtual Services",
        virtualservicesavailable: "Virtual services available"
      },
      paymentmethods: {
        paymentmethods: "Payment Methods",
        freeservice: "Free Service",
        payoutofpocket: "Pay out of Pocket"
      },
      linkstoadditionalharmreductionresources: {
        linkstoadditionalharmreductionresources:
          "Links to additional harm reduction resources"
      },
      linkstoadditionalpeerandfamilysupportresources: {
        linkstoadditionalpeerandfamilysupportresources:
          "Links to additional peer and family support resources"
      },
      telehealthservices: {
        telehealthservices: "Telehealth Services",
        telehealthavailable: "Telehealth Available"
      },
      eligibilitycriteria: {
        eligibilitycriteria: "Eligibility Criteria",
        genderanygender: "Gender - Any Gender",
        gendermalesonly: "Gender - Males Only",
        genderfemalesonly: "Gender - Females Only",
        pregnantfemalesaccepted: "Pregnant Females Accepted",
        agenominors: "Age - No Minors",
        ageonlyminors: "Age - Only Minors",
        ageminorsaccepted: "Age - Minors Accepted",
        sexoffendersaccepted: "Sex Offenders Accepted",
        nosexoffenders: "No Sex Offenders",
        arsonistsaccepted: "Arsonists Accepted",
        noarsonists: "No Arsonists",
        criminaljusticeclientsonly: "Criminal Justice Clients Only",
        criminaljusticeclientsaccepted: "Criminal Justice Clients Accepted",
        childprotectiveservicesclientsaccepted:
          "Child Protective Services Clients Accepted"
      },
      focusesandaccommodations: {
        focusesandaccommodations: "Focuses and Accommodations",
        transgenderaccommodated: "Transgender accommodated",
        veteransfocused: "Veterans focused",
        lgbtqfocused: "LGBTQ focused",
        lgbtqfriendly: "LGBTQ friendly",
        autismspectrumdisorderasdfriendly:
          "Autism Spectrum Disorder (ASD) Friendly",
        nosmoking: "No Smoking",
        smokingallowed: "Smoking allowed",
        accompanyingminorsallowed: "Accompanying minors allowed",
        childprotectiveservicesclientfocused:
          "Child protective services client focused",
        suicidalpatientsfocused: "Suicidal patients focused"
      },
      insuranceaccepted: {
        insuranceaccepted: "Insurance Accepted",
        veteransadministrationvabenefits:
          "Veterans Administration (VA) benefits",
        medicaid: "Medicaid",
        medicare: "Medicare",
        privateinsurance: "Private insurance",
        selfpay: "Self-Pay",
        criminaljusticecourtreferral: "Criminal Justice/Court referral",
        uninsured: "Uninsured"
      },
      mentalhealthconcerns: {
        mentalhealthconcerns: "Mental Health Concerns",
        anxiety: "Anxiety",
        depression: "Depression",
        posttraumaticstressdisorderptsd:
          "Post-Traumatic Stress Disorder (PTSD)",
        attentiondeficithyperactivitydisorderadhd:
          "Attention-Deficit/Hyperactivity Disorder (ADHD)",
        bipolardisorder: "Bipolar Disorder",
        personalitydisordersborderlineantisocialetc:
          "Personality Disorders (Borderline, Antisocial, etc.)",
        obsessivecompulsivedisorderocd: "Obsessive Compulsive Disorder (OCD)",
        schizophreniapsychoticdisorders: "Schizophrenia & Psychotic Disorders",
        eatingdisorders: "Eating Disorders"
      },
      interventionsused: {
        interventionsused: "Interventions Used",
        cognitivebehavioraltherapy: "Cognitive Behavioral Therapy",
        motivationalinterviewing: "Motivational Interviewing",
        "12stepprogram": "12-Step Program",
        harmreduction: "Harm reduction",
        traumafocusedcounseling: "Trauma-Focused Counseling",
        dialecticalbehaviortherapy: "Dialectical Behavior Therapy",
        interactivejournaling: "Interactive Journaling",
        solutionfocused: "Solution-Focused",
        psychoeducation: "Psychoeducation",
        contingencymanagementtherapy: "Contingency Management Therapy"
      },
      matsuboxone: {
        matsuboxone: "MAT - Suboxone",
        provideorprescribe: "Provide or prescribe",
        allowbutdonotprovide: "Allow but do not provide",
        donotallow: "Do not allow"
      },
      matsublocadeinjection: {
        matsublocadeinjection: "MAT - Sublocade Injection",
        provideorprescribe: "Provide or prescribe",
        allowbutdonotprovide: "Allow but do not provide",
        donotallow: "Do not allow"
      },
      matmethadone: {
        matmethadone: "MAT - Methadone",
        provideorprescribe: "Provide or prescribe",
        allowbutdonotprovide: "Allow but do not provide",
        donotallow: "Do not allow"
      },
      matvivitrol: {
        matvivitrol: "MAT - Vivitrol",
        provideorprescribe: "Provide or prescribe",
        allowbutdonotprovide: "Allow but do not provide",
        donotallow: "Do not allow"
      },
      matcampral: {
        matcampral: "MAT - Campral",
        provideorprescribe: "Provide or prescribe",
        allowbutdonotprovide: "Allow but do not provide",
        donotallow: "Do not allow"
      },
      matantabuse: {
        matantabuse: "MAT - Antabuse",
        provideorprescribe: "Provide or prescribe",
        allowbutdonotprovide: "Allow but do not provide",
        donotallow: "Do not allow"
      },
      additionalservicesonsite: {
        additionalservicesonsite: "Additional Services On-Site",
        applyingformedicaid: "Applying for Medicaid",
        birthcontrol: "Birth Control",
        casemanagement: "Case Management",
        childcare: "Childcare",
        compassionateprenatalcare: "Compassionate prenatal care",
        eapcounseling: "EAP Counseling",
        employmenttraining: "Employment training",
        familysupportclasses: "Family support classes",
        hivhepatitistesting: "HIV/Hepatitis testing",
        housingassistance: "Housing assistance",
        legalassistance: "Legal assistance",
        needleexchange: "Needle exchange",
        obtainingged: "Obtaining GED",
        obtainingid: "Obtaining ID",
        obtainingnarcan: "Obtaining Narcan",
        peerrecovery: "Peer recovery",
        recoverymeetings: "Recovery meetings",
        primarycaredoctor: "Primary care doctor",
        smokingcessation: "Smoking cessation",
        transportationassistance: "Transportation assistance",
        serviceprovidedathome: "Service provided at home",
        serviceprovidedathospital: "Service provided at hospital",
        serviceprovidedatjail: "Service provided at jail",
        asllanguageassistance: "ASL language assistance",
        spanishlanguageassistance: "Spanish language assistance",
        chineselanguageassistance: "Chinese language assistance",
        computertranslationinterpretationservice:
          "Computer Translation/Interpretation Service"
      },
      walkinswelcome: {
        walkinswelcome: "Walk-Ins Welcome",
        yes: "yes",
        no: "no"
      },
      restricted: {
        restricted: "Restricted Access",
        availabilityonlyinbusinesshours: "Availability only in Business hours"
      }
    },
    servicePage: {
      slotavailability: "Slot Availability",
      open: {
        servicehours: "Service Hours",
        walkinhours: "Walk-In Hours",
        intakehours: "Intake Hours"
      },
      agencydescription: "Agency Description",
      servicedescription: "Service Description",
      additionalinformationandcriteria: "Additional Information and Criteria",
      provideorprescribe: "Provide or prescribe",
      allowbutdonotprovide: "Allow but do not provide",
      donotallow: "Do not allow"
    },
    privacypolicy: {
      privacypolicy: "Privacy Policy",
      thisprivacypolicyiseffectiveforallusers: {
        title: "This Privacy Policy is effective for all users.",
        description:
          "Thank you for visiting <i>drughelp.care</i>, a website designed to enhance access to substance use treatment. Consistent with the provisions of the Internet Security and Privacy Act, the Freedom of Information Law, and the Personal Privacy Protection Law, this policy describes the <i>drughelp.care</i> privacy practices regarding information collected from users of this website. This policy describes what information is collected and how that information is used.<br><br> The terms “we”, “us”, and “<i>drughelp.care</i>” refer to drughelp.care, a website being developed by researchers at Cleveland State University in Cleveland, Ohio. When you use the site, you consent to our collection, use, and disclosure of information about you as described in this Privacy Policy."
      },
      informationcollectedautomaticallywhenyouvisitthiswebsiteandhowweuseit: {
        title:
          "Information Collected Automatically When You Visit This Website and How We Use It",
        description:
          "We may collect and store information about you in connection with your use of the site. We will use your computer’s IP address to distinguish among you and other users. We will collect information about the search filters, sorting options, and search terms that you use. We will use this information to personalize what you see on the website based on your history of use, allowing you to access the information that you need more quickly."
      },
      accesstoyourlocation: {
        title: "Access To Your Location",
        description:
          "You have the option to opt into location services to allow us to better assist you. We do not automatically collect information about your location. You must allow us to access your location to utilize certain features of this website, including finding services near you. However, the rest of the information on this website is fully functional without allowing us to access your location."
      },
      informationcollectedwhenyoucreateanagencyaccount: {
        title: "Information Collected When You Create an Agency Account",
        description:
          "If you create a <i>drughelp.care</i> Agency Account, we may store and use the information you provide during that process, such as your full name, email address, agency name, agency address, and phone number. We may publicly display your agency name, as well as any other content you submit through the registration process, as part of your agency account profile. Your email address and phone number can be used to contact you. If you believe that someone has created an unauthorized account depicting your agency, you can request its removal by contacting us at <a href='mailto:admin@drughelp.care' style='color:#3d97d3'><strong>admin@drughelp.care</strong></a>."
      },
      cookies: {
        title: "Cookies",
        description:
          "Cookies are used to distinguish among users of this website. This is a standard practice among Internet websites. Cookies may have unique identifiers, and reside on your computer, mobile device, in emails we send to you, on our web pages, or other places. This website uses cookies to store information about your use of the website, including your history of search filters, sorting options, or terms that you use to search our website."
      },
      informationcollectedwhenyouemailus: {
        title: "Information Collected When You Email Us",
        description:
          "During your visit to this website you may send an e-mail to <i>drughelp.care</i>. Your e-mail address and the contents of your message will be collected. The information collected includes text, audio, video, and graphic information formats included in the message. Your e-mail address and the information included in your message will be used to respond to you, to address issues you identify, and to improve this website."
      },
      security: {
        title: "Security",
        description:
          "We use various defenses to protect the personal information submitted to us, both during transmission and when we receive it. However, no method of transmission over the Internet or via mobile device is 100% secure. Therefore, we will strive to protect your personal information, but we cannot guarantee its absolute security."
      },
      contact: {
        title: "Contact",
        description:
          "Please <a href='mailto:admin@drughelp.care' style='color:#3d97d3'><strong>contact</strong></a> us if you have any questions/concerns on our Privacy Policy."
      }
    },
    quickSearchQuestions: {
      note:
        "Drughelp.care does not store your search activity. Your answers to these questions will only be used to match you to the best treatment services.",
      q1: {
        question: "Are you 18 years old or older?",
        yes: "Yes",
        no: "No"
      },
      q2: {
        question: "What is your gender?",
        female: "Female",
        male: "Male",
        other: "Other"
      },
      q3: {
        question: "Are you pregnant?",
        yes: "Yes",
        no: "No"
      },
      q4: {
        question: "Are you a veteran?",
        yes: "Yes",
        no: "No",
        familymemberofaveteranmilitaryservicemember:
          "Family member of a veteran/military service member",
        idontknow: "I don't know"
      },
      q5: {
        question: "What kind of insurance do you have?",
        noinsurance: "No insurance",
        medicare: "Medicare",
        medicaid: "Medicaid",
        privateinsurance: "Private insurance",
        vainsurance: "VA insurance",
        courtordered: "Court ordered",
        idontknow: "I don't know"
      },
      q6: {
        question: "Do you have any of these concerns?",
        subQ: "(You can choose more than one)",
        anxietydepression: "Anxiety/Depression",
        bipolardisorder: "Bipolar Disorder",
        personalitydisorders: "Personality Disorders",
        obsessivecompulsivedisorderocd: "Obsessive Compulsive Disorder (OCD)",
        schizophrenia: "Schizophrenia",
        eatingdisorders: "Eating Disorders",
        ptsd: "PTSD",
        adhd: "ADHD",
        noneidontknow: "None/I don't know"
      },
      q7: {
        question: "Which drug do you use?",
        subQ: "(You can choose more than one)",
        heroinpainpillsfentanylandorotheropioids:
          "Heroin, Pain pills, Fentanyl and/or other Opioids",
        alcohol: "Alcohol",
        benzosvaliumxanaxativan: "Benzos, Valium, Xanax, Ativan",
        marijuana: "Marijuana",
        cocaineandormeth: "Cocaine and/or Meth",
        otheridontknow: "Other/I don't know"
      },
      q8: {
        question: "Will you need a ride to your appointment?",
        yes: "Yes",
        no: "No"
      }
    },
    termsandconditions: {
      termsandconditionsofuse: {
        title: "Terms and Conditions of Use",
        description:
          "Welcome to <i>drughelp.care</i>. Our goal is to enhance access to substance use treatment by allowing individuals and treatment providers to more quickly find treatments and services.<br><br> These terms and conditions outline the rules and regulations for the use of <i>drughelp.care</i>'s website. <i>drughelp.care</i> is a website being developed by researchers at Cleveland State University in Cleveland, Ohio, United States. By accessing this website, we assume you accept these terms and conditions in full. Do not continue to use <i>drughelp.care</i>'s website if you do not accept all of the terms and conditions stated on this page."
      },
      thefollowingterminology: {
        title:
          "The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and any or all Agreements",
        description:
          "“Client”, “You” and “Your” refers to you, the person accessing this website and accepting the Company’s terms and conditions. “The Company”, “Ourselves”, “We”, “Our” and “Us”, refers to our Company. “Party”, “Parties”, or “Us”, refers to both the Client and ourselves, or either the Client or ourselves. All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner, whether by formal meetings of a fixed duration, or any other means, for the express purpose of meeting the Client’s needs in respect of provision of the Company’s stated services/products, in accordance with and subject to, prevailing law of . Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as referring to same."
      },
      cookies: {
        title: "Cookies",
        description:
          "We employ the use of cookies. By using <i>drughelp.care</i>'s website you consent to the use of cookies in accordance with <i>drughelp.care</i>’s privacy policy. Most of the modern-day interactive websites use cookies to enable us to retrieve user details for each visit. Cookies are used in some areas of our site to enable the functionality of this area and ease of use for those people visiting."
      },
      license: {
        title: "License",
        description:
          "Unless otherwise stated, <i>drughelp.care</i> and/or its licensors own the intellectual property rights for all material on <i>drughelp.care</i>. All intellectual property rights are reserved. You may view and/or print pages from http://drughelp.care/ for your own personal use subject to restrictions set in these terms and conditions.",
        youmustnot: {
          title: "You must not",
          bullets: [
            "Republish material from http://drughelp.care/",
            "Sell, rent, or sub-license material from http://drughelp.care/",
            "Reproduce, duplicate, or copy material from http://drughelp.care/",
            "Redistribute content from <i>drughelp.care</i> (unless content is specifically made for redistribution)"
          ]
        }
      },
      hyperlinkingtoourcontent: {
        title: "Hyperlinking to our Content",
        bullets: [
          "Government agencies",
          "Search engines",
          "News organizations",
          "Online directory distributors when they list us in the directory may link to our website in the same manner as they hyperlink to the websites of other listed businesses, and",
          "Systemwide Accredited Businesses except soliciting non-profit organizations, charity shopping malls, and charity fundraising groups which may not hyperlink to our website."
        ],
        description: {
          "1":
            "These organizations may link to our home page, to publications or to other website information so long as the link: (a) is not in any way misleading; (b) does not falsely imply sponsorship, endorsement, or approval of the linking party and its products or services; and (c) fits within the context of the linking party's site.",
          "2":
            "We may consider and approve in our sole discretion other link requests from other types of organizations. We will approve link requests from organizations if we determine that: (a) the link would not reflect unfavorably on us or our accredited businesses (for example, trade associations or other organizations representing inherently suspect types of business, such as work-at-home opportunities, shall not be allowed to link); (b) the organization does not have an unsatisfactory record with us; (c) the benefit to us from the visibility associated with the hyperlink outweighs the absence of ; and (d) where the link is in the context of general resource information or is otherwise consistent with editorial content in a newsletter or similar product furthering the mission of the organization.",
          "3":
            "If you are among the organizations listed above and are interested in linking to our website, you must notify us by sending an e-mail to admin@drughelp.care. Please include your name, your organization name, contact information (such as a phone number and/or e-mail address) as well as the URL of your site, a list of any URL's from which you intend to link to our website, and a list of the URL(s) on our site to which you would like to link. Allow 2-3 weeks for a response."
        },
        approvedorganizationsmayhyperlinktoourwebsiteasfollows: {
          title:
            "Approved organizations may hyperlink to our website as follows",
          bullets: [
            "By use of our corporate name; or",
            "By use of the uniform resource locator (web address) being linked to; or",
            "By use of any other description of our website or material being linked to that makes sense within the context and format of content on the linking party's site."
          ]
        },
        nouseoflogo:
          "No use of drughelp.care’s logo or other artwork will be allowed for linking absent a trademark license agreement."
      },
      cookies2: {
        title: "Cookies",
        description:
          "Cookies are used to distinguish among users of this website. This is a standard practice among Internet websites. Cookies may have unique identifiers, and reside on your computer, mobile device, in emails we send to you, on our web pages, or other places. This website uses cookies to store information about your use of the website, including your history of search filters, sorting options, or terms that you use to search our website."
      },
      reservationofrights: {
        title: "Reservation of Rights",
        description:
          "We reserve the right at any time and in its sole discretion to request that you remove all links or any particular link to our website. You agree to immediately remove all links to our website upon such request. We also reserve the right to amend these terms and conditions and its linking policy at any time. By continuing to link to our website, you agree to be bound to and abide by these linking terms and conditions."
      },
      removaloflinksfromourwebsite: {
        title: "Removal of links from our website",
        description:
          "If you find any link on our website or any linked website objectionable for any reason, you may contact us about this. We will consider requests to remove links but will have no obligation to do so or to respond directly to you. Whilst we endeavor to ensure that the information on this website is correct, we do not warrant its completeness or accuracy; nor do we commit to ensuring that the website remains available or that the material on the website is kept up to date."
      },
      contentliability: {
        title: "Content Liability",
        description:
          "We shall have no responsibility or liability for any content appearing on your website. You agree to indemnify and defend us against all claims arising out of or based upon your website. No link(s) may appear on any page on your website or within any context containing content or materials that may be interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third party rights."
      },
      disclaimer: {
        title: "Disclaimer",
        description: [
          "To the maximum extent permitted by applicable law, we exclude all representations, warranties, and conditions relating to our website and the use of this website (including, without limitation, any warranties implied by law in respect of satisfactory quality, fitness for purpose and/or the use of reasonable care and skill). Nothing in this disclaimer will",
          "The limitations and exclusions of liability set out in this Section and elsewhere in this disclaimer: (a) are subject to the preceding paragraph; and (b) govern all liabilities arising under the disclaimer or in relation to the subject matter of this disclaimer, including liabilities arising in contract, in tort (including negligence), and for breach of statutory duty. To the extent that the website and the information and services on the website are provided free of charge, we will not be liable for any loss or damage of any nature."
        ],
        bullets: [
          "limit or exclude our or your liability for death or personal injury resulting from negligence;",
          "limit or exclude our or your liability for fraud or fraudulent misrepresentation;",
          "limit any of our or your liabilities in any way that is not permitted under applicable law; or",
          "exclude any of our or your liabilities that may not be excluded under applicable law."
        ]
      },
      credit: {
        title: "Credit",
        description:
          "This terms and conditions page was created using the help of the termsandconditionstemplate.com generator."
      },
      contact: {
        title: "Contact",
        description:
          "If you have any queries regarding our terms, please <a href='mailto:admin@drughelp.care'>contact us.</a>"
      }
    },
    faq : {
      "frequentlyaskedquestions" : "Frequently Asked Questions",
      questions : [
        {
          "question" : "How do I search for treatment?",
          "answer" : "Click here for a <a href='/static/media/Drughelp.care_Quick_Guide_version_3.9f5c7e25.pdf'>Quick Guide to Using drughelp.care</a>"
        },
        {
          "question": "How do I get my agency listed on drughelp.care?",
          "answer": "We have a registration team ready to help you. Please email us at admin@drughelp.care. Registration takes about an hour (depending on how many services you provide), and we can help you over the phone or schedule a time to meet with you in person. We provide a Zoom option in addition to phone."
        },
        {
          "question": "What does it cost?",
          "answer": "Drughelp.care is free for agencies who want to list their services and free for anyone who wants to search for treatment and resources. It is developed by faculty and students at Cleveland State University to help our community."
        },
        {
          "question": "Do I have to be located in Cleveland to be listed on drughelp.care?",
          "answer": "Drughelp.care is developed by faculty and students at Cleveland State University in Cleveland, Ohio. Treatment providers throughout Northern Ohio who serve residents of Cuyahoga County are welcome to register on drughelp.care."
        },
        {
          "question": "How often do I have to update my agency’s slot information? Why?",
          "answer": "Drughelp.care is valuable because we provide real-time information about available treatment slots for people who want to get help immediately. We ask agencies to take a few seconds every morning to update information about the number of available slots and also wait time if no slot is available."
        },
          {
          "question": "How do I update my agency's slot information?",
          "answer": "Click here for a quick tutorial on <a href='https://drughelp.care/slot_update.pdf'>How to Update Available Slots</a>"
        },
        {
          "question": "What about my privacy? Will I get in trouble if I search for treatment or a needle exchange?",
          "answer": "Drughelp.care does not collect any personal information from people using the website. Your search is always anonymous."
        },
        {
          "question": "Who can I contact if I have more questions?",
          "answer": "Please email <a href='mailto:admin@drughelp.care'>admin@drughelp.care</a> with any questions you have about our site."
        }
  ]
    },
    aboutusPage:{
      aboutPageDescription : [
        "Created for the community affected by the opioid crisis, drughelp.care is a free website that allows drug treatment providers to list the number of open treatment slots daily. The site is fully searchable, and quickly and efficiently matches substance users with the best available treatment services.",
        "Drughelp.care was developed by Dr. Miyuki Fukushima Tedor and Dr. Patricia Stoddard-Dare at Cleveland State University (CSU) in 2016. They met with over 100 community members over the years to develop the site. The technical specifications were designed by engineering graduate students with Dr. Wenbing Zhao, and they continue to refine and improve drughelp.care.",
        "Thanks to funding from the Woodruff Foundation (2018-2019) and the Centers for Disease Control and Prevention (2019-Present), a community outreach team led by our Community Outreach Consultant registers more and more treatment providers on the site every day. Treatment providers can register different types of services, including assessment, outpatient treatment, intensive outpatient treatment, partial hospitalization, residential treatment, inpatient treatment, sober living, harm reduction, and peer and family support.",
        "The multidisciplinary drughelp.care team continues to enhance and add features to the website with the help from professors Dr. Sathish Kumar and Dr. Anne Berry.",
        "Agencies interested in listing their services can contact <a style={{ color: '#3596d4' }} href='mailto:admin@drughelp.care'>admin@drughelp.care</a>."
      ],
      meetourteams: "Meet our teams",
      meetourteamsDescription : "Our team consists of five professors, undergraduate and graduate students at Cleveland State University, and a consultant for community outreach.",
      buttons : [
        "creators",
        "engineering",
        "registration",
        "graphic design",
        "crisis hotline"
      ],
      creators: "Creators",
      creatorsDescription : "Drughelp.care was developed by two professors who are members of Cleveland State University’s (CSU) Center for Behavioral Health Sciences and the Internet of Things (IOT) Collaborative.",
      aboutclevelandstateuniversity : "About Cleveland State University",
      aboutclevelandstateuniversityDescription : "Founded in 1964, Cleveland State University is a public research institution that provides a dynamic setting for Engaged Learning. With 17,000-plus students, ten colleges and schools, and more than 175 academic programs, CSU was again chosen for 2019 as one of America’s best universities by U.S. News World Report. Find more information at <a href='https://www.csuohio.edu/'>www.csuohio.edu</a>.",
      engineeringTeam : "Engineering Team",
      engineeringTeamDescription : "Our engineering team is led by two engineering professors and includes graduate students in various fields of engineering.",
      registrationTeam : "Registration Team",
      registrationTeamDescription : "Our registration team is led by a consultant and includes undergraduate students from the Department of Criminology, Anthropology, and Sociology.",
      graphicDesignTeam: "Graphic Design Team",
      graphicDesignTeamDescription: "Our graphic design team is led by a graphic design professor and includes graphic design undergraduate students.",
      crisisHotlineTeam: "Crisis Hotline Team",
      crisisHotlineTeamDescription : "Our Crisis Hotline page was developed by students in the Department of Psychology."
    }

  }
};
export default data;
